import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';

/* PAGES */
import Sigin from 'pages/Signin';
import ForgotPassword from 'pages/ForgotPassword';
import TokenResetPassword from 'pages/TokenResetPassword';

import Chamadas from 'pages/Chamada';
import ChamadaStoreAndEdit from 'pages/Chamada/store';
import ClosedCaptionEditor from 'pages/ClosedCaptionEditor';
import Comercial from 'pages/Comercial';
import ComerciaisGravados from 'pages/ComerciaisGravados';
import ComerciaisNaoGravados from 'pages/ComerciaisNaoGravados';
import ComerciaisSemPlanilha from 'pages/ComerciaisSemPlanilha';
// import ComerciaisAutorizadosSemPlanilha from 'pages/ComerciaisAutorizadosSemPlanilha';
import Dashboard from 'pages/Dashboard';
import Exclusao from 'pages/Exclusao';
import ListaExclusaoId from 'pages/Exclusao/listaexclusaoid';
import GloboExpress from 'pages/GloboExpress';
import Kanban from 'pages/Chamada/kanban';
import LinhasRoteiro from 'pages/Roteiro/linhasroteiro';
import LinhasRoteiroEleicao from 'pages/Roteiro/linhasroteiroeleicao';
import ClosedCaption from 'pages/ClosedCaption';
import Perfil from 'pages/Perfil';
import Player from 'pages/Player';
import Promo from 'pages/Promo';
import Roteiro from 'pages/Roteiro';
import Usuarios from 'pages/Usuarios';
import UsuarioStoreAndEdit from 'pages/Usuarios/store';
import Historico from 'pages/Historico';
import Relatorio from 'pages/Relatorio';
import Programa from 'pages/Programa';
import OptativoLocal from 'pages/OptativoLocal';
import OptativoLocalStore from 'pages/OptativoLocal/store';
import SpotRadio from 'pages/SpotRadio';
import SpotRadioStoreAndEdit from 'pages/SpotRadio/store';
import MidiaAvulsa from 'pages/MidiaAvulsa';
import Painel from 'pages/Eleicoes/Painel';
import MapaMidia from 'pages/Eleicoes/MapaMidia';
import Substituicao from 'pages/Eleicoes/Substituicao';
import DashboardEleicoes from 'pages/Eleicoes/Dashboard';
import PromoCalendar from 'pages/PromoCalendar';
import RoteiroPromoStoreAndEdit from 'pages/RoteiroPromo/store';
import RoteiroPromo from 'pages/RoteiroPromo';
import ComerciaisReprovados from 'pages/ComerciaisReprovados';
import ComerciaisIndisponiveis from 'pages/ComerciaisIndisponiveis';
import IntervaloEleicao from 'pages/Programa/intervaloeleicao';
import SolicitacaoPromo from 'pages/SolicitacaoPromo';
import SolicitacaoPromoStoreAndEdit from 'pages/SolicitacaoPromo/store';
import SolicitacaoChamadaStore from 'pages/SolicitacaoChamada/store';
import SolicitacaoChamada from 'pages/SolicitacaoChamada';
import ORA from 'pages/ORA';
import ORAStoreAndEdit from 'pages/ORA/store';
import SolicitacaoDigital from 'pages/SolicitacaoDigital';
import SolicitacaoDigitalStore from 'pages/SolicitacaoDigital/store';
import SolicitacaoTelaoStore from 'pages/SolicitacaoPromo/telao';
import ChamadasAprovadas from 'pages/ChamadasAprovadas';
import AnuncioJornalStoreAndEdit from 'pages/AnuncioJornal/store';
import AnuncioJornal from 'pages/AnuncioJornal';
import MelhoriaDoBreak from 'pages/MelhoriaDoBreak';
import SugestaoPautaStore from 'pages/SugestaoPauta/store';
import SugestaoPauta from 'pages/SugestaoPauta';
import Arquivamento from 'pages/Arquivamento';
import LocucaoView from 'pages/Locucao/view';
import ChamadasValidas from 'pages/ChamadasValidas';
import OrientacaoExibicao from 'pages/OrientacaoExibicao';
import SugestaoPromoStore from 'pages/SugestaoPromo/store';
import SugestaoPromo from 'pages/SugestaoPromo';
import IndicadoresAvaliacaoEng from 'pages/IndicadoresAvaliacaoEng';
import Criativo from 'pages/Criativo/index';

export default function ADXRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Sigin />
          </PrivateRoute>
        }
      />
      <Route
        path="/esqueceusenha"
        element={
          <PrivateRoute>
            <ForgotPassword />
          </PrivateRoute>
        }
      />
      <Route
        path="/resetarsenha"
        element={
          <PrivateRoute>
            <TokenResetPassword />
          </PrivateRoute>
        }
      />
      <Route
        path="/resetarsenha/:resettoken"
        element={
          <PrivateRoute>
            <TokenResetPassword />
          </PrivateRoute>
        }
      />

      <Route
        path="/perfil"
        element={
          <PrivateRoute isPrivate>
            <Perfil />
          </PrivateRoute>
        }
      />
      <Route
        path="/closedcaption"
        element={
          <PrivateRoute isPrivate>
            <ClosedCaption />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute isPrivate>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/player"
        element={
          <PrivateRoute isPrivate>
            <Player />
          </PrivateRoute>
        }
      />
      <Route
        path="/materiais"
        element={
          <PrivateRoute isPrivate>
            <Comercial />
          </PrivateRoute>
        }
      />
      <Route
        path="/promos"
        element={
          <PrivateRoute isPrivate>
            <Promo />
          </PrivateRoute>
        }
      />
      <Route
        path="/roteiros"
        element={
          <PrivateRoute isPrivate>
            <Roteiro />
          </PrivateRoute>
        }
      />
      <Route
        path="/orientacoesexibicao"
        element={
          <PrivateRoute isPrivate>
            <OrientacaoExibicao />
          </PrivateRoute>
        }
      />
      <Route
        path="/exclusao"
        element={
          <PrivateRoute isPrivate>
            <Exclusao />
          </PrivateRoute>
        }
      />
      <Route
        path="/melhoriadobreak"
        element={
          <PrivateRoute isPrivate>
            <MelhoriaDoBreak />
          </PrivateRoute>
        }
      />
      <Route
        path="/arquivamento"
        element={
          <PrivateRoute isPrivate>
            <Arquivamento />
          </PrivateRoute>
        }
      />
      <Route
        path="/criativos"
        element={
          <PrivateRoute isPrivate>
            <Criativo />
          </PrivateRoute>
        }
      />

      <Route
        path="/anunciojornal"
        element={
          <PrivateRoute isPrivate>
            <AnuncioJornal />
          </PrivateRoute>
        }
      />

      <Route
        path="/anunciojornal/novo"
        element={
          <PrivateRoute isPrivate>
            <AnuncioJornalStoreAndEdit />
          </PrivateRoute>
        }
      />

      <Route
        path="/anunciojornal/:anunciojornalId"
        element={
          <PrivateRoute isPrivate>
            <AnuncioJornalStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/exclusao/:listaId"
        element={
          <PrivateRoute isPrivate>
            <ListaExclusaoId />
          </PrivateRoute>
        }
      />
      <Route
        path="/usuarios"
        element={
          <PrivateRoute isPrivate>
            <Usuarios />
          </PrivateRoute>
        }
      />
      <Route
        path="/usuarios/novo"
        element={
          <PrivateRoute isPrivate>
            <UsuarioStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/usuarios/:usuarioId"
        element={
          <PrivateRoute isPrivate>
            <UsuarioStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/comerciaisgravados"
        element={
          <PrivateRoute isPrivate>
            <ComerciaisGravados />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/chamadasvalidas"
        element={
          <PrivateRoute isPrivate>
            <ChamadasValidas />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/comerciaisnaogravados"
        element={
          <PrivateRoute isPrivate>
            <ComerciaisNaoGravados />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/comerciaissemplanilha"
        element={
          <PrivateRoute isPrivate>
            <ComerciaisSemPlanilha />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/globoexpress"
        element={
          <PrivateRoute isPrivate>
            <GloboExpress />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/midiasavulsas"
        element={
          <PrivateRoute isPrivate>
            <MidiaAvulsa />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/chamadasaprovadas"
        element={
          <PrivateRoute isPrivate>
            <ChamadasAprovadas />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/comerciaisindisponiveis"
        element={
          <PrivateRoute isPrivate>
            <ComerciaisIndisponiveis />
          </PrivateRoute>
        }
      />
      {/* <Route
        path="/dashboard/comerciaisautorizadossemplanilha"
        element={
          <PrivateRoute isPrivate>
            <Comercial />
          </PrivateRoute>ComerciaisAutorizadosSemPlanilha}
 
      /> */}
      <Route
        path="/dashboard/comerciaisreprovados"
        element={
          <PrivateRoute isPrivate>
            <ComerciaisReprovados />
          </PrivateRoute>
        }
      />
      <Route
        path="/roteiros/:roteiroId"
        element={
          <PrivateRoute isPrivate>
            <LinhasRoteiro />
          </PrivateRoute>
        }
      />
      <Route
        path="/roteiroseleicao/:roteiroId"
        element={
          <PrivateRoute isPrivate>
            <LinhasRoteiroEleicao />
          </PrivateRoute>
        }
      />
      <Route
        path="/chamadas"
        element={
          <PrivateRoute isPrivate>
            <Chamadas />
          </PrivateRoute>
        }
      />
      <Route
        path="/chamadas/aprovacao"
        element={
          <PrivateRoute isPrivate>
            <Chamadas />
          </PrivateRoute>
        }
      />
      <Route
        path="/chamadas/novo"
        element={
          <PrivateRoute isPrivate>
            <ChamadaStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/chamadas/:chamadaId"
        element={
          <PrivateRoute isPrivate>
            <ChamadaStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/chamadas/:chamadaId/kanban"
        element={
          <PrivateRoute isPrivate>
            <Kanban />
          </PrivateRoute>
        }
      />

      <Route
        path="/closedcaptioneditor"
        element={
          <PrivateRoute isPrivate>
            <ClosedCaptionEditor />
          </PrivateRoute>
        }
      />
      <Route
        path="/closedcaptioneditor/:midiaId"
        element={
          <PrivateRoute isPrivate>
            <ClosedCaptionEditor />
          </PrivateRoute>
        }
      />
      <Route
        path="/closedcaptioneditor/:midiaId/:type"
        element={
          <PrivateRoute isPrivate>
            <ClosedCaptionEditor />
          </PrivateRoute>
        }
      />

      <Route
        path="/historico/:midiaId"
        element={
          <PrivateRoute isPrivate>
            <Historico />
          </PrivateRoute>
        }
      />
      <Route
        path="/relatorios"
        element={
          <PrivateRoute isPrivate>
            <Relatorio />
          </PrivateRoute>
        }
      />
      <Route
        path="/indicadores/comercial"
        element={
          <PrivateRoute isPrivate>
            <IndicadoresAvaliacaoEng />
          </PrivateRoute>
        }
      />
      <Route
        path="/programas"
        element={
          <PrivateRoute isPrivate>
            <Programa />
          </PrivateRoute>
        }
      />
      <Route
        path="/optativoslocais"
        element={
          <PrivateRoute isPrivate>
            <OptativoLocal />
          </PrivateRoute>
        }
      />
      <Route
        path="/optativoslocais/novo"
        element={
          <PrivateRoute isPrivate>
            <OptativoLocalStore />
          </PrivateRoute>
        }
      />
      <Route
        path="/programas/intervaloeleicao"
        element={
          <PrivateRoute isPrivate>
            <IntervaloEleicao />
          </PrivateRoute>
        }
      />
      <Route
        path="/spotradio"
        element={
          <PrivateRoute isPrivate>
            <SpotRadio />
          </PrivateRoute>
        }
      />
      <Route
        path="/spotradio/aprovacao"
        element={
          <PrivateRoute isPrivate>
            <SpotRadio />
          </PrivateRoute>
        }
      />
      <Route
        path="/spotradio/novo"
        element={
          <PrivateRoute isPrivate>
            <SpotRadioStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/spotradio/:spotId"
        element={
          <PrivateRoute isPrivate>
            <SpotRadioStoreAndEdit />
          </PrivateRoute>
        }
      />

      <Route
        path="/eleicoes/painel"
        element={
          <PrivateRoute isPrivate>
            <Painel />
          </PrivateRoute>
        }
      />
      <Route
        path="/eleicoes/mapademidia"
        element={
          <PrivateRoute isPrivate>
            <MapaMidia />
          </PrivateRoute>
        }
      />
      <Route
        path="/eleicoes/mapademidia/:mapaId"
        element={
          <PrivateRoute isPrivate>
            <MapaMidia />
          </PrivateRoute>
        }
      />
      <Route
        path="/eleicoes/substituicao"
        element={
          <PrivateRoute isPrivate>
            <Substituicao />
          </PrivateRoute>
        }
      />
      <Route
        path="/eleicoes/dashboard"
        element={
          <PrivateRoute isPrivate>
            <DashboardEleicoes />
          </PrivateRoute>
        }
      />
      <Route
        path="/calendariopromo"
        element={
          <PrivateRoute isPrivate>
            <PromoCalendar />
          </PrivateRoute>
        }
      />
      <Route
        path="/roteiropromo"
        element={
          <PrivateRoute isPrivate>
            <RoteiroPromo />
          </PrivateRoute>
        }
      />
      <Route
        path="/roteiropromo/aprovacao"
        element={
          <PrivateRoute isPrivate>
            <RoteiroPromo />
          </PrivateRoute>
        }
      />
      <Route
        path="/roteiropromo/novo"
        element={
          <PrivateRoute isPrivate>
            <RoteiroPromoStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/roteiropromo/:roteiroId"
        element={
          <PrivateRoute isPrivate>
            <RoteiroPromoStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/solicitacaopromo/novo"
        element={
          <PrivateRoute isPrivate>
            <SolicitacaoPromoStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/solicitacaopromo/:solicitacaoId"
        element={
          <PrivateRoute isPrivate>
            <SolicitacaoPromoStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/solicitacaopromo"
        element={
          <PrivateRoute isPrivate>
            <SolicitacaoPromo />
          </PrivateRoute>
        }
      />
      <Route
        path="/solicitacaochamada"
        element={
          <PrivateRoute isPrivate>
            <SolicitacaoChamada />
          </PrivateRoute>
        }
      />
      <Route
        path="/solicitacaochamada/novo/:tipo"
        element={
          <PrivateRoute isPrivate>
            <SolicitacaoChamadaStore />
          </PrivateRoute>
        }
      />
      <Route
        path="/ora"
        element={
          <PrivateRoute isPrivate>
            <ORA />
          </PrivateRoute>
        }
      />
      <Route
        path="/ora/novo"
        element={
          <PrivateRoute isPrivate>
            <ORAStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/ora/:oraId"
        element={
          <PrivateRoute isPrivate>
            <ORAStoreAndEdit />
          </PrivateRoute>
        }
      />
      <Route
        path="/solicitacaodigital"
        element={
          <PrivateRoute isPrivate>
            <SolicitacaoDigital />
          </PrivateRoute>
        }
      />
      <Route
        path="/solicitacaodigital/novo"
        element={
          <PrivateRoute isPrivate>
            <SolicitacaoDigitalStore />
          </PrivateRoute>
        }
      />
      <Route
        path="/solicitacaopromo/:solicitacaoId/solicitacaotelao/:telao"
        element={
          <PrivateRoute isPrivate>
            <SolicitacaoTelaoStore />
          </PrivateRoute>
        }
      />
      <Route
        path="/sugestaopauta"
        element={
          <PrivateRoute isPrivate>
            <SugestaoPauta />
          </PrivateRoute>
        }
      />
      <Route
        path="/sugestaopauta/novo"
        element={
          <PrivateRoute isPrivate>
            <SugestaoPautaStore />
          </PrivateRoute>
        }
      />
      <Route
        path="/sugestaopromo"
        element={
          <PrivateRoute isPrivate>
            <SugestaoPromo />
          </PrivateRoute>
        }
      />
      <Route
        path="/sugestaopromo/novo"
        element={
          <PrivateRoute isPrivate>
            <SugestaoPromoStore />
          </PrivateRoute>
        }
      />
      <Route
        path="/locucao/roteiro/:roteiroId"
        element={
          <PrivateRoute isPrivate>
            <LocucaoView />
          </PrivateRoute>
        }
      />
      <Route
        path="/locucao/chamada/:chamadaId"
        element={
          <PrivateRoute isPrivate>
            <LocucaoView />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}
